import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import { Box, Flex, Text } from '@mantine/core'

import { type CoreQuotePreviewItem } from '@flecto/types'
import { Icon, TextCurrency } from '@flecto/ui'

import { useDocumentState } from '../../../booking-documents/hooks/useDocumentState'
import { getTaxBracket } from '../../../booking-documents/services/getTaxBracket'
import { TextBookingProductPricingRule } from '../../../booking-products/components/TextBookingProductPricingRule/TextBookingProductPricingRule'

type SectionBookingItem = {
  parentCategoryLabel: string
  categoryLabel: string
  items: CoreQuotePreviewItem[]
  showTaxes: boolean
  lastColumnSize: string
}

export function SectionBookingItem({
  parentCategoryLabel,
  categoryLabel,
  items,
  showTaxes,
  lastColumnSize,
}: SectionBookingItem) {
  const { taxes, translate } = useDocumentState()

  return (
    <Box mb='sm'>
      <Flex direction='row' align='center'>
        {parentCategoryLabel && (
          <>
            <Text c='gray.7' fz='sm' fw={500}>
              {parentCategoryLabel}
            </Text>
            <Icon
              icon={faCaretRight}
              mt={1}
              mr={3}
              ml={2}
              color='gray.7'
              size='xs'
            />
          </>
        )}
        <Text c='gray.7' fz='sm' fw={500}>
          {categoryLabel}
        </Text>
      </Flex>
      {items?.map((item, index) => (
        <Box key={index} mb='sm'>
          <Flex justify='space-between' mt='xs'>
            <Box w='50%'>
              <Text fw={500} size='md'>
                {item.item.title}
              </Text>
              <TextBookingProductPricingRule
                quotePreviewBookingProduct={item}
                size='md'
              />
            </Box>
            <Box w='10%'>
              <Text size='md'>x{item.quantity}</Text>
            </Box>
            {showTaxes && getTaxBracket && (
              <Box w='10%'>
                <Text c='gray.7' size='md'>
                  {item.taxable
                    ? taxes &&
                      getTaxBracket(String(item?.tax_rate_percent), taxes)
                        ?.percentage
                    : 0}
                  %
                </Text>
              </Box>
            )}
            <Flex
              display='flex'
              align='flex-end'
              justify='flex-start'
              w={lastColumnSize}
              direction='column'
            >
              <TextCurrency
                cents={
                  (showTaxes ? item.price_with_vat_cents : item.price_cents) ??
                  0
                }
                size='md'
              />
              {item.deposit_cents > 0 && (
                <Flex gap='xs'>
                  <Text c='gray.7' tt='lowercase' size='md'>
                    + {translate?.('label_deposit')}
                  </Text>
                  <TextCurrency
                    c='gray.7'
                    cents={item.deposit_cents}
                    size='md'
                  />
                </Flex>
              )}
            </Flex>
          </Flex>
        </Box>
      ))}
    </Box>
  )
}
